import type { BrandAppBannerConfig } from '../../configs/types'

export function isTopBannerRoute(config: BrandAppBannerConfig['topBanner'], name: string | null | undefined, from: unknown) {
  if (!config || !name)
    return false
  if (name === 'login')
    return typeof from === 'string' && config.loginSources.includes(from)
  return config.routes.includes(name)
}

export function createBannerSession(storage: Pick<Storage, 'getItem' | 'setItem'>, brand: string) {
  const key = `app-banner-dismissed:${brand}`
  let dismissed = false
  return {
    isDismissed() {
      try {
        dismissed ||= storage.getItem(key) === '1'
      }
      catch { /* 禁用存储时仍保留内存中的关闭状态 */ }
      return dismissed
    },
    dismiss() {
      dismissed = true
      try {
        storage.setItem(key, '1')
      }
      catch { /* 禁用存储不影响关闭 */ }
    },
  }
}
